import { Suspense, lazy, type ComponentProps } from 'react';
import type { RichText as RichTextView, RichTextEditor as Editor } from './RichTextEditor';

/**
 * The editor (TipTap and ProseMirror) is heavy — about 128 kB gzipped — and
 * only the mail pages use it. Loaded on demand, the rest of the admin stays as
 * light as it was; the first mail page fetches it once.
 */
const EditorChunk = lazy(() => import('./RichTextEditor').then((m) => ({ default: m.RichTextEditor })));
const ViewChunk = lazy(() => import('./RichTextEditor').then((m) => ({ default: m.RichText })));

export function RichTextEditor(props: ComponentProps<typeof Editor>) {
  // As tall as the editor it stands in for: its toolbar and its empty text.
  const height = props.compact ? 'h-[156px]' : 'h-[226px]';
  return (
    <Suspense fallback={<div className={`${height} rounded-md border hairline bg-[var(--surface-raised)]`} aria-busy />}>
      <EditorChunk {...props} />
    </Suspense>
  );
}

export function RichText(props: ComponentProps<typeof RichTextView>) {
  return (
    <Suspense fallback={<div className="h-6" aria-busy />}>
      <ViewChunk {...props} />
    </Suspense>
  );
}
